import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, User, MagnifyingGlass, List, X } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { count, setOpen } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  const onSearch = (e) => {
    e.preventDefault();
    if (q.trim()) {
      navigate(`/products?q=${encodeURIComponent(q.trim())}`);
      setMenuOpen(false);
      setSearchOpen(false);
    }
  };

  return (
    <header className="border-b border-zinc-900 bg-white sticky top-0 z-40">
      <div className="marquee">
        <div className="marquee-track">
          <span>NZ Imports · Dispatched From Auckland · Free Shipping Over $100 · Pay Securely With Stripe</span>
          <span>NZ Imports · Dispatched From Auckland · Free Shipping Over $100 · Pay Securely With Stripe</span>
          <span>NZ Imports · Dispatched From Auckland · Free Shipping Over $100 · Pay Securely With Stripe</span>
        </div>
      </div>
      <div className="flex items-stretch border-b border-zinc-900">
        <Link to="/" data-testid="nav-logo" className="px-4 md:px-8 py-4 border-r border-zinc-900 flex items-center gap-2 hover:bg-zinc-900 hover:text-white transition-colors">
          <span className="text-2xl md:text-3xl font-black tracking-tighter uppercase font-[Outfit]">Stuff<span className="text-[#ff3333]">ly</span></span>
        </Link>

        <form onSubmit={onSearch} className="hidden md:flex flex-1 items-center border-r border-zinc-900">
          <MagnifyingGlass size={20} weight="bold" className="mx-4" />
          <input
            data-testid="nav-search-input"
            type="text" value={q} onChange={e => setQ(e.target.value)}
            placeholder="SEARCH 4,900+ PRODUCTS"
            className="flex-1 h-full bg-transparent outline-none text-sm uppercase tracking-widest placeholder:text-zinc-400 font-[Outfit] font-bold"
          />
        </form>

        <div className="flex-1 md:hidden" />
        <Link to="/products" data-testid="nav-shop" className="hidden md:flex items-center px-6 border-r border-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors text-xs uppercase tracking-widest font-[Outfit] font-bold">Shop All</Link>
        <Link to="/blog" data-testid="nav-blog" className="hidden md:flex items-center px-6 border-r border-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors text-xs uppercase tracking-widest font-[Outfit] font-bold">Blog</Link>

        {user?.role === "admin" && (
          <Link to="/admin" data-testid="nav-admin" className="hidden md:flex items-center px-6 border-r border-zinc-900 hover:bg-[#0055ff] hover:text-white transition-colors text-xs uppercase tracking-widest font-[Outfit] font-bold">Admin</Link>
        )}

        {user ? (
          <div className="hidden md:flex">
            <Link to="/account" data-testid="nav-account" className="flex items-center gap-2 px-5 border-r border-zinc-900 hover:bg-zinc-900 hover:text-white text-xs uppercase tracking-widest font-[Outfit] font-bold">
              <User size={18} weight="bold" /> {user.name.split(" ")[0].toLowerCase() === "admin" ? "Account" : user.name.split(" ")[0]}
            </Link>
            <button data-testid="nav-logout" onClick={logout} className="px-5 border-r border-zinc-900 hover:bg-zinc-900 hover:text-white text-xs uppercase tracking-widest font-[Outfit] font-bold">Logout</button>
          </div>
        ) : (
          <Link to="/login" data-testid="nav-login" className="hidden md:flex items-center gap-2 px-5 border-r border-zinc-900 hover:bg-zinc-900 hover:text-white text-xs uppercase tracking-widest font-[Outfit] font-bold">
            <User size={18} weight="bold" /> Login
          </Link>
        )}

        <button data-testid="nav-search-toggle" onClick={() => { setSearchOpen(v => !v); setMenuOpen(false); }} className="md:hidden px-3 border-l border-zinc-900" aria-label="Search">
          <MagnifyingGlass size={20} weight="bold" />
        </button>

        <button data-testid="nav-cart" onClick={() => setOpen(true)} className="flex items-center gap-2 px-3 md:px-5 border-l border-zinc-900 md:border-l-0 hover:bg-[#ff3333] hover:text-white transition-colors text-xs uppercase tracking-widest font-[Outfit] font-bold">
          <ShoppingCart size={20} weight="bold" /> <span className="hidden sm:inline">Cart</span> [{count}]
        </button>

        <button onClick={() => { setMenuOpen(v => !v); setSearchOpen(false); }} className="md:hidden px-4 border-l border-zinc-900" data-testid="nav-menu-toggle">
          {menuOpen ? <X size={22} /> : <List size={22} />}
        </button>
      </div>
      {searchOpen && (
        <form onSubmit={onSearch} className="md:hidden flex items-stretch border-b border-zinc-900">
          <input
            data-testid="nav-search-input-mobile"
            autoFocus
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="SEARCH 4,900+ PRODUCTS"
            className="flex-1 min-w-0 px-4 py-3 bg-transparent outline-none text-sm uppercase tracking-widest placeholder:text-zinc-400 font-[Outfit] font-bold"
          />
          <button type="submit" data-testid="nav-search-submit-mobile" className="px-5 bg-[#ff3333] text-white flex items-center" aria-label="Search">
            <MagnifyingGlass size={18} weight="bold" />
          </button>
        </form>
      )}
      {menuOpen && (
        <div className="md:hidden border-b border-zinc-900 flex flex-col">
          <Link to="/products" onClick={() => setMenuOpen(false)} className="px-4 py-4 border-b border-zinc-200 text-xs font-bold uppercase tracking-widest">Shop All</Link>
          <Link to="/blog" onClick={() => setMenuOpen(false)} className="px-4 py-4 border-b border-zinc-200 text-xs font-bold uppercase tracking-widest">Blog</Link>
          {user?.role === "admin" && <Link to="/admin" onClick={() => setMenuOpen(false)} className="px-4 py-4 border-b border-zinc-200 text-xs font-bold uppercase tracking-widest text-[#0055ff]">Admin</Link>}
          {user ? <>
            <Link to="/account" onClick={() => setMenuOpen(false)} className="px-4 py-4 border-b border-zinc-200 text-xs font-bold uppercase tracking-widest">Account</Link>
            <button onClick={() => { logout(); setMenuOpen(false); }} className="px-4 py-4 text-left text-xs font-bold uppercase tracking-widest">Logout</button>
          </> : <>
            <Link to="/login" onClick={() => setMenuOpen(false)} className="px-4 py-4 border-b border-zinc-200 text-xs font-bold uppercase tracking-widest">Login</Link>
            <Link to="/register" onClick={() => setMenuOpen(false)} className="px-4 py-4 text-xs font-bold uppercase tracking-widest">Register</Link>
          </>}
        </div>
      )}
    </header>
  );
}
